import { Swiper, SwiperSlide } from 'swiper/react';
import { useRouter } from 'next/router';
import SwiperCore, { Navigation, Scrollbar, A11y } from 'swiper';
import styles from './index.module.scss';
import { worksSwiperData } from '@/constants/powerStream';
import { useLang } from '@/i18n';
import { createEFPic } from '@/utils/useEFPic';

const { EFPic } = createEFPic('/media/power-stream/detail/pc/');
SwiperCore.use([Navigation, Scrollbar, A11y]);

export default function Works() {
    const { locale } = useRouter();
    const { t } = useLang('powerstream.detail.works');
    const swiperData = worksSwiperData(locale as string);

    return (
        <div className={`${styles.works} works`}>
            <div className="title-box">
                <p className="works-title">{t('title')}</p>
                <p className="works-desc">{t('desc')}</p>
            </div>
            <div className="content-box">
                <Swiper
                    modules={[Navigation]}
                    navigation={true}
                    pagination={false}
                    spaceBetween={40}
                    slidesPerView="auto"
                    className="solution-swiper"
                    width={1080}
                    grabCursor
                >
                    {swiperData.map((item: any, index) => (
                        <SwiperSlide key={index} className="swiper-item">
                            <div className="item-box">
                                <EFPic className="item-img" name={item?.src} />
                                <p className="item-title">{item?.product}</p>
                                <div className="item-desc-box">
                                    <p className="item-desc item-battery">
                                        <span className="item-svg battery-svg" />
                                        {item?.battery}
                                    </p>
                                    <p className="item-desc item-surge">
                                        <span className="item-svg surge-svg" />
                                        {item?.surge}
                                    </p>
                                    <p className="item-desc item-capacity">
                                        <span className="item-svg capacity-svg" />
                                        {item?.capacity}
                                    </p>
                                </div>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
            <p className="remark">{t('remark')}</p>
        </div>
    );
}
